exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".extend-to-bottom[data-v-9952a4ea]{display:flex;flex-direction:column;position:fixed;left:0;bottom:0;padding-bottom:60px;padding-right:0;border-top:1px solid #ddd;z-index:100;width:100%;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9952a4ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/MobileCheckoutFooter.vue
// module id = jv2i
// module chunks = 18